/**
 * RoadDefectsPanel - Panel de inventario de defectos viales
 *
 * @module roadways/components/panels
 * @description Wrapper que utiliza BaseInventoryPanel con configuración de defectos viales
 */

import { BaseInventoryPanel } from '../../../../layouts/panels/LeftPanel';
import { roadDefectsInventoryConfig } from '../../config/road-defects-inventory.config';

/**
 * Panel de inventario de defectos viales
 *
 * @remarks
 * Usa BaseInventoryPanel genérico con configuración específica.
 * Incluye: narrow/wide modes, paginación, sorting, multi-select, eye/zoom buttons, color picker.
 */
export function RoadDefectsPanel(): JSX.Element {
  return <BaseInventoryPanel config={roadDefectsInventoryConfig} />;
}
